import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesTranslationsRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-translations',
	path: '/secure/admin/ViewTranslations!default.jspa',
	query: ['issueConstantType=issuetype'],
};
